<template>
  <!--办理须知-->
  <div class="announcement">
    <div class="common-width">
      <div class="common-main-body" aria-label="系统升级维护公告">
        <div class="title">
          停机维护公告
        </div>
        <div class="time">
          2024-12-31
        </div>
        <div class="main-content">
          尊敬的用户：<br/>
          <div style="text-indent: 36px">为进一步优化完善我省”退休一件事“服务，于 2024 年 12 月 31 日 18 时至 2025 年 1月 25 日 24 时进行升级改造。升级改造维护期间，本系统暂停提供”退休一件事“服务。由此带来不便，敬请谅解。在此期间，如需办理企业职工基本养老保险待遇相关事项请到广东省人力资源和社会保障厅网上服务平台进行办理，地址为：https://hrss.gd.gov.cn/gdsbfw/</div>
          <div style="text-indent: 36px">特此公告。</div>
        </div>
<!--        <div class="content-footer">-->
<!--          <div>技术支持组</div>-->
<!--          <div>2024年12月31日</div>-->
<!--        </div>-->
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "announcement",
  data() {
    return {
    };
  },
  computed: {},
  methods: {

  },
  async created() {

  },
  mounted() {

  }
};
</script>

<style lang="scss" scoped>
.common-main-body{
  width: 800px;
  margin: 0 auto;
}
.announcement {
  margin-top: 40px;
  margin-bottom: 40px;

  .common-main-body {
    margin-bottom: 130px;

    .title {
      text-align: left;
      font-size: 36px;
      margin: 50px 0 30px;
    }
    .time{
      font-size: 16px;
      font-weight: 400;
      color: #999;
      line-height: 24px;
      padding: 0 0 20px;
      border-bottom: 1px solid #f1f1f1;
    }
    .main-content{
      font-size: 18px;
      font-weight: 400;
      color: #0D1C28;
      line-height: 50px;
      margin-top: 20px;
    }
    .content-footer{
      font-size: 18px;
      font-weight: 400;
      color: #0D1C28;
      line-height: 50px;
      text-align: right;
    }
  }
}
</style>
